import React, { createContext, useState, useContext } from "react";

const VendorContext = createContext();

export const VendorProvider = ({ children }) => {
  const [selectedVendor, setSelectedVendor] = useState(-1);
  const [vendors, setVendors] = useState([]);

  return (
    <VendorContext.Provider
      value={{ selectedVendor, setSelectedVendor, vendors, setVendors }}
    >
      {children}
    </VendorContext.Provider>
  );
};
export const useVendor = () => useContext(VendorContext);
